<template>
  <header class="harit-header">
    <div class="harit-header-inner">
      <router-link to="/dashboard" class="harit-brand" aria-label="Harit by HCL Foundation">
        <!-- White knockout variant, for the green masthead. -->
        <HaritLogo variant="full" theme="white" :height="46" />
      </router-link>

      <nav>
        <ul class="harit-nav">
          <li v-for="link in visibleLinks" :key="link.to">
            <router-link :to="link.to" class="harit-nav-link" :class="{ 'is-active': isActive(link.to) }">
              <span v-html="link.icon" class="d-inline-flex"></span>
              {{ link.name }}
            </router-link>
          </li>
        </ul>
      </nav>

      <div class="harit-header-actions">
        <button class="harit-bell" type="button" aria-label="Notifications" @click="goToPending()">
          <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.7 21a2 2 0 0 1-3.4 0" />
          </svg>
          <span class="harit-bell-count" v-if="pendingCount > 0">{{ pendingCount > 99 ? '99+' : pendingCount }}</span>
        </button>

        <AppHeaderDropdownAccnt />
      </div>
    </div>
  </header>
</template>

<script>
import axios from 'axios'
import store from '../store'
import AppHeaderDropdownAccnt from './AppHeaderDropdownAccnt'
import HaritLogo from './HaritLogo.vue'

const ICON_DASHBOARD =
  '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>'

const ICON_USERS =
  '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>'

const ICON_TEST =
  '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 3h6"/><path d="M10 3v6.5L4.8 18a2 2 0 0 0 1.7 3h11a2 2 0 0 0 1.7-3L14 9.5V3"/><path d="M7.5 15h9"/></svg>'

export default {
  name: 'AppHeader',
  components: {
    AppHeaderDropdownAccnt,
    HaritLogo,
  },
  data() {
    return {
      baseURL: store.state.baseURL,
      // Every signed-in role may browse the directory; only Super-Admin sees
      // the write actions, and that is enforced on the page and the API.
      navLinks: [
        { name: 'Dashboard', to: '/dashboard', icon: ICON_DASHBOARD },
        { name: 'Users', to: '/users', icon: ICON_USERS },
        { name: 'Test', to: '/test', icon: ICON_TEST, role: 'Super-Admin' },
      ],
      pendingCount: 0,
    }
  },
  computed: {
    // Read through the store so the nav settles as soon as isLoggedIn resolves
    // the session, rather than from a stale data() snapshot.
    visibleLinks() {
      const role = this.$store.state.user && this.$store.state.user.role
      return this.navLinks.filter((link) => !link.role || link.role === role)
    },
  },
  created() {
    this.getPendingCount()
  },
  methods: {
    isActive(path) {
      return this.$route.path === path || this.$route.path.startsWith(path + '/')
    },
    goToPending() {
      if (this.$route.path !== '/dashboard') this.$router.push('/dashboard')
    },
    // The bell badge counts cases still waiting on someone, which is the only
    // notification the panel actually has today.
    getPendingCount() {
      axios({
        url: this.baseURL + 'case/numbers',
        method: 'POST',
        headers: { authorization: store.state.token },
        data: {},
      })
        .then((res) => {
          if (res.data.status) this.pendingCount = res.data.data.totalPending || 0
        })
        .catch(() => {
          this.pendingCount = 0
        })
    },
  },
}
</script>
